const statusBadgeColor = (background, border, color) => ({
    badge: {
        background,
        border,
        color,
    },
});
export default statusBadgeColor;
